<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单号">
              <a-input v-model="queryParams.wipEntityNameVal" allowClear placeholder="支持Excel复制批量搜索" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工单状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectMultiple"
                :selectData="statusList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.assemblyItemIdList"
                selectType="selectMultipleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode"
                :dropdown-match-select-width="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="产线">
              <global-select
                :value.sync="queryParams.lineIdList"
                selectType="selectMultiple"
                :selectData="lineCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.desOrganizationCodeList"
                selectType="selectMultipleFilter"
                requestApi="/system/user/inventOrgAll"
                @change="getBomWorkshopFindList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="车间">
              <a-select v-model="queryParams.workshopCodes" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
                  {{ item.workshopCode }}-{{ item.workshopDesc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="工单分类">
              <global-select
                :value.sync="queryParams.classCodeList"
                selectType="selectMultiple"
                :selectData="classCodeList"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划单号">
              <a-input v-model="queryParams.orderNoVal" allowClear placeholder="支持Excel复制批量搜索" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="创建人">
              <global-select
                :value.sync="queryParams.createBy"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/founderBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="jobCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划开始时间">
              <a-tooltip>
                <a-range-picker
                  v-model="scheduledStartDate"
                  @change="handleScheduledStartDateChange"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划完成时间">
              <a-tooltip>
                <a-range-picker
                  v-model="scheduledCompletionDate"
                  @change="handleScheduledCompletionDateChange"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="审批状态">
              <global-select
                :value.sync="queryParams.approvalStatusList"
                selectType="selectMultiple"
                :selectData="approvalStatusList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="零部件&组装">
              <a-select v-model="queryParams.wipEntityFlag" allowClear>
                <a-select-option v-for="item in wipEntityFlagList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="是否分仓">
              <global-select
                :value.sync="queryParams.warehouseFlag"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SYS_YES_NO' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="一次达交考核时间" :labelCol="{ style: { width: '120px' } }">
              <a-tooltip>
                <a-range-picker
                  v-model="deliveryDate"
                  @change="handleDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="考核交期">
              <a-tooltip>
                <a-range-picker
                  v-model="assessmentDeliveryDate"
                  @change="handleAssessmentDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="派工时间">
              <a-tooltip>
                <a-range-picker
                  v-model="dispatchingDate"
                  @change="(val) => handleUpdateDate(val, ['staDispatchingDate', 'endDispatchingDate'])"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="开工时间">
              <a-tooltip>
                <a-range-picker
                  v-model="startDate"
                  @change="(val) => handleUpdateDate(val, ['staStartDate', 'endStartDate'])"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="完工时间">
              <a-tooltip>
                <a-range-picker
                  v-model="completionDate"
                  @change="(val) => handleUpdateDate(val, ['staCompletionDate', 'endCompletionDate'])"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="第一次报工时间" :labelCol="{ style: { width: '120px' } }">
              <a-tooltip>
                <a-range-picker
                  v-model="firstReportingTime"
                  @change="(val) => handleUpdateDate(val, ['staFirstReportingTime', 'endFirstReportingTime'])"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="创建日期">
              <a-tooltip>
                <a-range-picker
                  v-model="createTime"
                  @change="(val) => handleUpdateDate(val, ['staCreateTime', 'endCreateTime'])"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="组件物料">
              <global-select
                ref="materils"
                v-model="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBoxNew"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ organizationCode: 'A001' }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="大货类型">
              <global-select
                v-model="queryParams.orderTypeList"
                :dropdown-match-select-width="false"
                requestApi="/system/lookup/data/list"
                selectType="selectMultiple"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'ORDER_TYPE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="供应商">
              <global-select
                v-model="queryParams.vendorCode"
                selectType="selectAssembleSearch"
                searchParam="supplier"
                requestApi="/scp/scpProductionScheduling/getSupplierList"
                :selectItem="{ value: 'supplierCode', label: 'supplierName' }"
                :setParams="{ organizationCode: organizationCodeOrigin }"
                :assembleLabel="true"
                :dropdown-match-select-width="false" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="未完成数量交期" :labelCol="{ style: { width: '120px' } }">
              <a-tooltip>
                <a-range-picker
                  v-model="estimatedDeliveryDate"
                  @change="handleEstimatedDeliveryDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="handleQuery('查询')" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper line-height37" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mes:mesDiscreteJobs:add']">新增</a-button>
      <a-button @click="handleXd(selectedRowKeys)" :loading="xdLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:release']">下达</a-button>
      <a-button @click="handleCallOff()" :loading="callOffLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:cancellation']">取消</a-button>
      <a-button @click="handleGdch(selectedRowKeys)" :loading="gdchLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:withdraw']">工单撤回</a-button>
      <a-button @click="handleYcwg(selectedRowKeys)" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:abnormalCompletion']">异常完工</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['mes:mesDiscreteJobs:import']">工单导入</a-button>
      <download-modal :apiFun="exportUrl" ref="download" />
      <a-button @click="handleExport" type="primary" v-hasPermi="['mes:mesDiscreteJobs:export']">导出</a-button>
      <a-button @click="importTemplate" type="primary" v-hasPermi="['mes:mesDiscreteJobs:template']">下载模板</a-button>
      <a-button @click="handleClose(selectedRowKeys)" type="primary" :loading="closeLoading" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreateJob:close']">关闭工单</a-button>
      <a-button type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:batchUpdateDestination']" @click="handleDestination">修改目的仓</a-button>
      <a-upload name="file" :customRequest="handleImport" :showUploadList="false" accept=".xlsx,.xls">
        <a-button type="primary" :loading="closeUploading" v-hasPermi="['mes:mesDiscreteJobs:batchCloseImport']">关闭工单导入</a-button>
      </a-upload>
      <a-button type="primary" @click="handleDownloadTemplate" v-hasPermi="['mes:mesDiscreteJobs:batchCloseTemplate']">关闭工单导入模板</a-button>
      <a-button @click="handleRefresh" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:refreshPackageVersion']">刷新包装版本</a-button>
      <a-button @click="handleUpdateTime" :loading="btnLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:linkageSuperTime']">联动上级工单时间</a-button>
      <refresh-version-modal ref="RefreshVersionModalRef" @reSearch="handleOk" />
      <a-button type="primary" :loading="deliveryLoading" @click="handleUpdateAssessmentDelivery" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:submitAssessment']">修改考核交期</a-button>
      <update-assessment-delivery-date ref="updateAssessmentDeliveryDateRef" @reSearch="handleOk" />
      <a-button @click="handlePrintPicking" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:getMaterialPrintList']">打印领料单</a-button>
      <a-button @click="$refs.backFlushModalRef.show()" type="primary" v-hasPermi="['mes:mesDiscreteJobs:xbcBackFlushMaterialIssuance']">触发倒冲领料</a-button>
      <a-button :loading="btnLoading" type="primary" :disabled="selectedRowKeys.length === 0" v-hasPermi="['mes:mesDiscreteJobs:getByRequirementIds']" @click="handleMaterialChange">发起物料变更</a-button>
      <pick-material-modal ref="pickMaterialModalRef" />
      <cancel-modal ref="cancelModalRef" @reSearch="getList" />
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-tabs :default-active-key="currentTab" type="card" @change="tabOnchange">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.key"></a-tab-pane>
        </a-tabs>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 3300 }"
          @selectedRowChange="selectedRowChange"
        >
          <template #scheduledStartDateTitle>
            <span>计划开始时间</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('scheduledStartDate')" type="edit" title="编辑"/>
          </template>
          <template #scheduledCompletionDateTitle>
            <span>计划完成时间</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('scheduledCompletionDate')" type="edit" title="编辑"/>
          </template>
          <!--          <template #deliveryDateTitle>
            <span>一次达交考核时间</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('deliveryDate')" type="edit" title="编辑"/>
          </template>-->
          <template #dateEditAfterTodayTitle>
            <span>未完成数量交期</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('estimatedDeliveryDate')" type="edit" title="编辑"/>
          </template>
          <template #roItemCodeTitle>
            <span>组件物料</span>
            <a-icon v-if="currentTab==='工单用料表'" class="action-icon" @click.stop="onMaterialEdit('roItemCode')" type="edit" title="编辑"/>
          </template>
          <template #quantityPerAssemblyTitle>
            <span>用量</span>
            <a-icon v-if="currentTab==='工单用料表'" class="action-icon" @click.stop="onMaterialEdit('quantityPerAssembly')" type="edit" title="编辑"/>
          </template>
          <!--          <template #assessmentDeliveryDateTitle>
            <span>考核交期</span>
            <a-icon v-if="currentTab==='工单信息'" class="action-icon" @click.stop="onEditDate('assessmentDeliveryDate')" type="edit" title="编辑"/>
          </template>-->
          <template slot="vendorCode" slot-scope="{ text, record }">
            <a-tooltip class="text-3-ellipsis" :title="text ? (text + '-' + record.supplierName) : ''" placement="topLeft">
              {{ text ? (text + '-' + record.supplierName) : '' }}
            </a-tooltip>
          </template>
          <template slot="scheduledStartDate" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.scheduledStartDate"
              format="YYYY-MM-DD HH:mm:ss"
              size="small"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled="sList.includes(text.record.status)"
              :disabled-date="disabledDate"
            />
          </template>
          <template slot="scheduledCompletionDate" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.scheduledCompletionDate"
              format="YYYY-MM-DD HH:mm:ss"
              size="small"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled="sList.includes(text.record.status)"
              :disabled-date="disabledDate"
            />
          </template>
          <template slot="formatDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="drawingVersion" slot-scope="text">
            <span>{{ text.text || '-' }}</span>
          </template>
          <template slot="deliveryDate" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
            <!--            <a-date-picker
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.deliveryDate"
              format="YYYY-MM-DD HH:mm:ss"
              size="small"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              :disabled="sList.includes(text.record.status)"
              :disabled-date="disabledDate"
            />-->
          </template>
          <template slot="dateFormat" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD') }}</span>
          </template>
          <template slot="dateEditAfterToday" slot-scope="{ text, record, column }">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <a-date-picker
              v-if="isEdit && currentId === record.id"
              v-model="record[column.dataIndex]"
              valueFormat="YYYY-MM-DD 00:00:00"
              size="small"
              :disabled-date="disabledDate"
            />
          </template>
          <!--考核交期-->
          <template slot="assessmentDeliveryDate" slot-scope="{ text, record }">
            <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <!--            <span v-if="!isEdit || currentId !== record.id">
              <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
              <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </span>
            <span v-if="isEdit && currentId === record.id">
              <a-date-picker
                v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'"
                v-model="record[column.dataIndex]"
                valueFormat="YYYY-MM-DD 00:00:00"
                size="small"
              />
              <a-date-picker
                v-else
                v-model="record[column.dataIndex]"
                format="YYYY-MM-DD HH:mm:ss"
                size="small"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </span>-->
          </template>
          <template slot="workCode" slot-scope="{ record }" >
            <span v-if="!isEdit || currentId !== record.id">{{ record.workCode }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.workCode"
              requestApi="/mes/mesDiscreteJobs/workCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ organizationCode: record.desOrganizationCode }"
              :allowClear="false"
              size="small"
              :disabled="sList.includes(record.status)"
              :dropdown-match-select-width="false"
              @change="workCodeChange(record)"
            />
          </template>
          <template slot="lineCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.lineCode }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record.lineCode"
              requestApi="/mes/mesDiscreteJobs/lineCodeBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ workCode: record.workCode }"
              :allowClear="false"
              size="small"
              :disabled="sList.includes(record.status)"
              :dropdown-match-select-width="false"
            />
          </template>
          <template slot="mrpFlag" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.mrpFlag }}</span>
            <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record.mrpFlag" size="small" :disabled="sList.includes(text.record.status)">
              <a-select-option v-for="(item) in yesOrNo" :key="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </template>
          <template slot="remarks" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.remarks }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.remarks" size="small" />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['mes:mesDiscreteJobs:edit']">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
            <a class="ml10" @click="handleLog(text.record)">日志</a>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
        :confirmLoading="uploadLoading"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      <work-order-desk-add
        ref="createModal"
        @handle-success="handleOk"
      />
      <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk2" />
      <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      <BatchEditModal ref="BatchEditModalRef" @click="handleOk" />
      <updateMaterialModal ref="UpdateMaterialModalRef" @handle-success="handleOk" />
      <DestinationWarehouseModal ref="DestinationWarehouseModalRef" @handle-success="handleOk" />
      <MaterialChangeModal
        v-if="modalShow.materialChangeModal"
        ref="materialChangeModalRef"
        @successCall="materialChangeSuccess" />
      <back-flush-modal ref="backFlushModalRef" @success="handleOk" />
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';
import {
  apiMesDiscreteJobsList,
  apiMesRequirementOperationsList,
  apiMesOperationsList,
  apiMesDiscreteJobsAssociatedWorkOrderList,
  apiMesDiscreteJobsWorkCodeBox,
  apiMesDiscreteJobsLineCodeBox,
  apiMesDiscreteJobsUpdate,
  apiMesDiscreteJobsClassCodeBox,
  apiMesDiscreteJobsRelease,
  apiMesDiscreteJobsWithdraw,
  apiMesDiscreteJobsAbnormalCompletion,
  apiMesDiscreteJobsTemplate,
  apiScpScreeningSchemeSearchAllScheme,
  apiMesOperationsExport,
  apiMesDiscreteJobsExport,
  apiAssociatedWorkOrderExport,
  apiMesRequirementOperationsExport,
  apiMesSelectMesWipLogList,
  apiBatchCloseImport, apiCheckAssessmentDeliveryDateCanSubmit,
  apiWorkOrderDeskLinkageSuperTime
} from '@/api/mes/workOrderManage/workOrderDesk'
import { apiMesDiscreateBatchClose } from '@/api/mes/workOrderManage/workOrderSent'
import Cookies from 'js-cookie';
import WorkOrderDeskAdd from './components/work-order-desk-add'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { generateLsTableResData } from '@/utils/util.js';
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import deepClone from "lodash.clonedeep";
import BatchEditModal from './components/batch-edit-modal'
import updateMaterialModal from './components/update-material-modal'
import DestinationWarehouseModal from "@/views/mes/workOrderManage/workOrderDesk/components/destination-warehouse-modal.vue"
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import cacheRequest from '@/mixins/cacheRequest'
import { parseResFileOrJson } from '@/utils/request'
import RefreshVersionModal from "@/views/mes/workOrderManage/workOrderDesk/components/refresh-version-modal.vue"
import updateAssessmentDeliveryDate from "@/views/mes/workOrderManage/workOrderDesk/components/update-assessment-delivery-date.vue"
import pickMaterialModal from "@/views/mes/workOrderManage/workOrderDesk/components/pick-material-modal.vue"
import { apiBomWorkshopFindList } from '@/api/mes/basedata/factoryAssembly'
import cancelModal from '@/views/mes/workOrderManage/workOrderDesk/components/cancel-modal.vue'
import MaterialChangeModal from '@/views/mes/workOrderManage/workOrderDesk/components/material-change-modal.vue'
import BackFlushModal from './components/back-flush-modal.vue'

export default {
  name: 'WorkOrderDesk',
  components: {
    WorkOrderDeskAdd,
    DressingByScreening,
    DressingByScreeningSetUp,
    DownloadModal,
    BatchEditModal,
    DestinationWarehouseModal,
    cancelModal,
    OperationLogModel,
    RefreshVersionModal,
    updateAssessmentDeliveryDate,
    updateMaterialModal,
    MaterialChangeModal,
    pickMaterialModal,
    BackFlushModal
  },
  mixins: [cacheRequest],
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      modalShow: {
        materialChangeModal: false
      },
      btnLoading: false,
      deliveryLoading: false, // 考核交期loading
      uploadLoading: false, // 上传loading
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      cacheEditObj: null, // 缓存当前编辑的行数据
      uploadConfig: { // 导入限制
        accept: '.xls,.xlsx',
        limitNumber: 1
        // limitSize: 100
      },
      closeUploading: false, // 关闭工单上传中
      workshopCodeList: [], // 车间编码
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiMesDiscreteJobsList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/mes/mesDiscreteJobs/import'
      },
       // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 控制搜索展开
      advanced: true,
      scheduledCompletionDate: undefined, // 计划完成时间
      scheduledStartDate: undefined, // 计划开始时间
      deliveryDate: undefined, // 一次达交考核时间
      assessmentDeliveryDate: undefined, // 考核交期
      estimatedDeliveryDate: undefined, // 未完成数量交期
      dispatchingDate: undefined, // 派工时间
      startDate: undefined, // 开工时间
      completionDate: undefined, // 完工时间
      firstReportingTime: undefined, // 第一次报工时间
      createTime: undefined, // 创建时间
      showUpdateMaterial: false, // 是否展示修改工单用料表弹窗
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        organizationCode: undefined,
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        statusList: undefined,
        assemblyItemIdList: undefined,
        lineIdList: undefined,
        desOrganizationCodeList: undefined,
        classCodeList: undefined,
        orderNoVal: undefined,
        orderNoList: undefined,
        createBy: undefined,
        staScheduledCompletionDate: undefined,
        endScheduledCompletionDate: undefined,
        staScheduledStartDate: undefined,
        endScheduledStartDate: undefined,
        staEstimatedDeliveryDate: undefined,
        endEstimatedDeliveryDate: undefined,
        approvalStatusList: undefined,
        workshopCodes: undefined,
        wipEntityFlag: undefined,
        staDispatchingDate: undefined,
        endDispatchingDate: undefined,
        staStartDate: undefined,
        endStartDate: undefined,
        staCompletionDate: undefined,
        endCompletionDate: undefined,
        staFirstReportingTime: undefined,
        endFirstReportingTime: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined,
        vendorCode: undefined,
        orderTypeList: undefined,
        itemIdList: undefined
      },
      // 快码表格数据
      typeList: [],
      tableLoading: false,
      columns: [],
      // 表格字段-工单信息
      columns1: [
        { title: '加工组织', dataIndex: 'desOrganizationName', fixed: 'left', width: 180, align: 'center' },
        { title: '工单号', fixed: 'left', width: 160, dataIndex: 'wipEntityName', align: 'center', ellipsis: true },
        { title: '供应商', width: 160, dataIndex: 'vendorCode', align: 'center', ellipsis: true, scopedSlots: { customRender: 'vendorCode' } },
        { title: '计划单号', width: 200, dataIndex: 'orderNo', align: 'center' },
        { title: '工单状态', width: 120, dataIndex: 'statusName', align: 'center' },
        { title: '审批状态', width: 120, dataIndex: 'approvalStatusName', align: 'center' },
        { title: '物料编码', width: 160, dataIndex: 'itemCode', align: 'center', ellipsis: true },
        { title: '物料名称', width: 120, dataIndex: 'itemName', align: 'center', ellipsis: true },
        { title: '规格描述', width: 120, dataIndex: 'description', align: 'center', ellipsis: true },
        { title: '单位', width: 120, dataIndex: 'primaryUomCode', align: 'center', ellipsis: true },
        { title: '计划数量', width: 120, dataIndex: 'planQuantity', align: 'center', ellipsis: true },
        { title: '完工数量', width: 120, dataIndex: 'quantityCompleted', align: 'center', ellipsis: true },
        { title: '剩余数量', width: 120, dataIndex: 'quantityRemaining', align: 'center', ellipsis: true },
        { title: '已入库数量', width: 120, dataIndex: 'receivedQuantity', align: 'center', ellipsis: true },
        { title: '已送货数量', width: 120, dataIndex: 'deliveredQuantity', align: 'center', ellipsis: true },
        { title: '交期变更套数', width: 120, dataIndex: 'assessmentChangeQuantity', align: 'center' },
        {
          // title: '未完成数量交期',
          dataIndex: 'estimatedDeliveryDate',
          scopedSlots: { customRender: 'dateEditAfterToday', title: "dateEditAfterTodayTitle" },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          // title: '计划开始时间',
          dataIndex: 'scheduledStartDate',
          scopedSlots: { customRender: 'scheduledStartDate', title: "scheduledStartDateTitle" },
          width: 170,
          align: 'center',
          ellipsis: true
        },
        {
          // title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          scopedSlots: { customRender: 'scheduledCompletionDate', title: "scheduledCompletionDateTitle" },
          width: 170,
          align: 'center',
          ellipsis: true
        },
        { title: '下达时间', dataIndex: 'releaseDate', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center', ellipsis: true },
        {
          title: '派工时间',
          dataIndex: 'dispatchingDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        { title: '开工时间', dataIndex: 'startDate', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center', ellipsis: true },
        {
          title: '完工时间',
          dataIndex: 'completionDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '入库时间',
          dataIndex: 'receivedDate',
          scopedSlots: { customRender: 'receivedDate' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '一次达交考核时间',
          dataIndex: 'deliveryDate',
          scopedSlots: { customRender: 'deliveryDate' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '变更后考核交期',
          dataIndex: 'assessmentDeliveryDate',
          scopedSlots: { customRender: 'assessmentDeliveryDate' },
          width: 170,
          align: 'center',
          ellipsis: true
        },
        {
          title: '第一次报工时间',
          width: 160,
          dataIndex: 'firstReportingTime',
          scopedSlots: { customRender: 'formatDate' },
          align: 'center'
        },
        {
          title: '审批时间',
          dataIndex: 'approvalDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        { title: '是否分仓', width: 120, dataIndex: 'warehouseFlag', align: 'center', ellipsis: true },
        { title: '是否打印标签', width: 120, dataIndex: 'printFlag', align: 'center', ellipsis: true },
        { title: '佛山仓数量', width: 100, dataIndex: 'currentCpDivideQty', align: 'center' },
        { title: '基地仓数量', width: 100, dataIndex: 'currentJdcDivideQty', align: 'center' },
        { title: '卫星仓数量', width: 100, dataIndex: 'currentWxcDivideQty', align: 'center' },
        { title: '基地仓理货数量', width: 120, dataIndex: 'currentJdclhDivideQty', align: 'center' },
        { title: '拖套比', width: 100, dataIndex: 'trayRatioQty', align: 'center' },
        { title: '工厂检验结果', width: 100, dataIndex: 'qualifiedFlag', align: 'center' },
        { title: 'QC检验结果', width: 100, dataIndex: 'qcQualifiedFlag', align: 'center' },
        { title: '是否锁库', width: 100, dataIndex: 'lockStockFlag', align: 'center' },
        { title: '完工子库', width: 120, dataIndex: 'completedSublibrary', align: 'center', ellipsis: true },
        { title: '完工货位', width: 120, dataIndex: 'completedLocation', align: 'center', ellipsis: true },
        { title: '需求组织', width: 120, dataIndex: 'finishedProductJobOrg', align: 'center', ellipsis: true },
        { title: '工单类型', width: 120, dataIndex: 'jobTypeName', align: 'center', ellipsis: true },
        { title: '工单分类', width: 120, dataIndex: 'classCode', align: 'center', ellipsis: true },
        { title: '大货类型', width: 110, dataIndex: 'orderTypeName', align: 'center', ellipsis: true },
        {
          title: '车间',
          dataIndex: 'workCode',
          scopedSlots: { customRender: 'workCode' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '产线',
          dataIndex: 'lineCode',
          scopedSlots: { customRender: 'lineCode' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '签价单号',
          dataIndex: 'alternativeMaterialList',
          scopedSlots: { customRender: 'alternativeMaterialList' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        { title: 'BOM版本号字段', dataIndex: 'bomVersion', scopedSlots: { customRender: 'bomVersion' }, width: 150, align: 'center', ellipsis: true },
        {
          title: '包装BOM版本号',
          dataIndex: 'packageVersion',
          scopedSlots: { customRender: 'packageVersion' },
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: 'CC工单拆解状态',
          dataIndex: "ccDisassemblyIs",
          align: 'center',
          width: 140
        },
        {
          title: 'CC工单拆解错误原因',
          dataIndex: "ccDisassemblyErrorReason",
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: 'MRP净值',
          dataIndex: 'mrpFlag',
          scopedSlots: { customRender: 'mrpFlag' },
          width: 130,
          align: 'center',
          ellipsis: true
        },
        {
          title: '备注',
          width: 120,
          dataIndex: 'remarks',
          scopedSlots: { customRender: 'remarks' },
          align: 'center',
          ellipsis: true,
          type: "input"
        },
        { title: '取消原因', width: 120, dataIndex: 'cancelReason', align: 'center', ellipsis: true },
        { title: '创建人', width: 120, dataIndex: 'createName', align: 'center', ellipsis: true },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
        { title: '分仓修改标识', width: 120, dataIndex: 'divideWarehouseUpdateFlag', align: 'center' },
        { title: '分仓修改时间', width: 150, dataIndex: 'divideWarehouseUpdateTime', align: 'center' },
        { title: '分仓时间', width: 150, dataIndex: 'divideWarehouseTime', align: 'center' },
        { title: '标准图纸版本', dataIndex: 'drawingVersion', scopedSlots: { customRender: 'drawingVersion' }, width: 140, align: 'center', ellipsis: true }
      ],
      // 表格字段-工单用料表
      columns2: [
        { title: '加工组织', dataIndex: 'desOrganizationName', width: 180, fixed: 'left', align: 'center' },
        { title: '工单号', dataIndex: 'wipEntityName', width: 160, fixed: 'left', align: 'center' },
        { title: '工单状态', dataIndex: 'statusName', width: 100, fixed: 'left', align: 'center' },
        { title: '成品-物料编码', dataIndex: 'itemCode', fixed: 'left', width: 160, align: 'center' },
        { title: '成品-物料名称', width: 160, dataIndex: 'productName', align: 'center', ellipsis: true },
        { title: '成品-规格描述', dataIndex: 'description', width: 120, align: 'center', ellipsis: true },
        {
          // title: '组件物料',
          dataIndex: 'roItemCode',
          width: 120,
          scopedSlots: { title: "roItemCodeTitle" },
          align: 'center'
        },
        { title: '组件-物料名称', width: 120, dataIndex: 'roItemName', align: 'center', ellipsis: true },
        { title: '组件-规格描述', dataIndex: 'zuDescription', width: 180, align: 'center', ellipsis: true },
        { title: '单位', dataIndex: 'primaryUomCode', width: 120, align: 'center' },
        {
          // title: '用量',
          dataIndex: 'quantityPerAssembly',
          width: 120,
          scopedSlots: { title: "quantityPerAssemblyTitle" },
          align: 'center'
        },
        { title: '产出率', dataIndex: 'componentYield', width: 120, align: 'center' },
        { title: '必须', dataIndex: 'requiredQuantity', width: 120, align: 'center' },
        { title: '已发料', dataIndex: 'quantityIssued', width: 120, align: 'center' },
        { title: '未发料', dataIndex: 'quantityOpen', width: 120, align: 'center' },
        { title: '供应类型', dataIndex: 'wipSupplyTypeName', width: 120, align: 'center' },
        { title: '集采类型', dataIndex: 'purchaseTypeName', width: 120, align: 'center' },
        { title: 'MRP净值', width: 120, dataIndex: 'mrpFlag', align: 'center' },
        { title: '供应子库', width: 120, dataIndex: 'supplySublibrary', align: 'center' },
        { title: '供应货位', width: 120, dataIndex: 'supplyLocation', align: 'center' },
        { title: '需求日期', dataIndex: 'dateRequired', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
        { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' }
      ],
      // 表格字段-工单工序
      columns3: [
        { title: '加工组织', dataIndex: 'desOrganizationName', width: 180, fixed: 'left', align: 'center' },
        { title: '工单号', width: 180, fixed: 'left', dataIndex: 'wipEntityName', align: 'center' },
        { title: '工单状态', width: 120, dataIndex: 'statusName', align: 'center' },
        { title: '审批状态', width: 120, dataIndex: 'approvalStatusName', align: 'center' },
        { title: '物料编码', width: 160, dataIndex: 'itemCode', align: 'center' },
        { title: '物料名称', width: 160, dataIndex: 'itemName', align: 'center' },
        { title: '规格描述', width: 180, dataIndex: 'description', align: 'center', ellipsis: true },
        { title: '工序序号', width: 160, dataIndex: 'operationSeqNum', align: 'center' },
        { title: '工序代码', width: 120, dataIndex: 'operationCode', align: 'center' },
        { title: '工序说明', width: 120, dataIndex: 'operationDesc', align: 'center' },
        { title: '车间', width: 120, dataIndex: 'workCode', align: 'center' },
        { title: '生产线', width: 120, dataIndex: 'lineCode', align: 'center' },
        { title: '流转状态', width: 120, dataIndex: 'status', align: 'center' },
        { title: '需求数量', width: 120, dataIndex: 'requiredQty', align: 'center' },
        { title: '等待数量', width: 120, dataIndex: 'waitQty', align: 'center' },
        { title: '完成数量', width: 120, dataIndex: 'completedQty', align: 'center' },
        { title: '工序类型', width: 120, dataIndex: 'operationTypeName', align: 'center' },
        { title: '工序开工时间', dataIndex: 'processStartTime', width: 150, align: 'center' },
        { title: '第一次工序报工时间', dataIndex: 'firstReportingTime', width: 170, align: 'center' },
        { title: '最后一次工序报工时间', dataIndex: 'lastReportingTime', width: 170, align: 'center' },
        { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
        { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
        { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 页签
      currentTab: "工单信息",
      tabList: [
        { key: "工单信息" },
        { key: "工单用料表" },
        { key: "工单工序" },
        { key: "关联工单" }
      ],
      scrollWidth: 4200,
      // MRP净值
      yesOrNo: [
        { key: "Y", value: "是" },
        { key: "N", value: "否" }
      ],
      searchList1: [],
      searchList2: [],
      workCodeList: [], // 车间
      lineCodeList: [], // 产线
      classCodeList: [], // 工单分类
      approvalStatusList: [], // 审批状态
      statusList: [], // 工单状态
      wipEntityFlagList: [], // 零部件&组装
      // 发放、派工、开工、完成、暂时、异常完成、取消、入库不可编辑
      sList: ["ISSUED", "DISPATCHED", "START_WORK", "COMPLETED", "SUSPENDED", "ABNORMAL_COMPLETION", "CANCELED", "RECEIVED"],
      orderNos: [],
      exportUrl: "", // 导出接口
      xdLoading: false,
      callOffLoading: false,
      gdchLoading: false,
      closeLoading: false
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  mounted () {
    // this.onSearch()
  },
  created () {
    this.uploadLoading = false;
    this.columns = JSON.parse(JSON.stringify(this.columns1))
    this.tabOnchange("工单信息")
    this.getWorkCodeBox()
    this.getLineCodeBox()
    this.getClassCodeBox()
    this.cacheLookupRequest('MES_JOB_APPROVAL_STATUS', { lookupType: 'MES_JOB_APPROVAL_STATUS', current: 1, pageSize: 999 }, 'approvalStatusList')
    this.cacheLookupRequest('MES_JOB_STATUS', { lookupType: 'MES_JOB_STATUS', current: 1, pageSize: 999 }, 'statusList')
    this.cacheLookupRequest('MES_JOB_FLAG', { lookupType: 'MES_JOB_FLAG', current: 1, pageSize: 999 }, 'wipEntityFlagList')
    this.getCategoryIdList(true)
  },
  methods: {
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(valField, listField) {
      const listVal = []
      if (this.queryParams[valField]) {
        const list = this.queryParams[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      this.queryParams[listField] = listVal
    },
    // 发起变更
    handleMaterialChange() {
      if(this.currentTab !== '工单用料表') {
        return this.$message.warning("请选择工单用料表进行操作")
      }
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请至少勾选一条单据进行操作")
      }
      const notAllow = this.selectedRows.find(item => !(['RELEASED', 'UNRELEASED', 'DISPATCHED'].includes(item.status)));
      if(notAllow) {
        return this.$message.warning("工单状态为‘已下达’‘未下达’‘已派工’才能发起变更")
      }
      this.modalShow.materialChangeModal = true;
      this.$nextTick(() => {
        this.$refs.materialChangeModalRef.show(this.selectedRows);
      })
    },
    // 物料变更成功
    materialChangeSuccess() {
      this.modalShow.materialChangeModal = false;
      this.handleOk();
    },
    // 车间编码
    getBomWorkshopFindList () {
      this.queryParams.workshopCodes = undefined;
      this.workshopCodeList = []
      if (this.queryParams?.desOrganizationCodeList?.length < 1) {
        return false
      }
      apiBomWorkshopFindList({ organizationCode: this.queryParams.desOrganizationCodeList }).then(res => {
        this.workshopCodeList = res
      })
    },
    // 打印领料单
    handlePrintPicking() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据")
      }
      this.$refs.pickMaterialModalRef.show(this.selectedRows, 'workOrderDesk')
    },
    // 修改目的仓
    handleDestination() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      if(this.selectedRows?.length > 1) {
        return this.$message.warning("只能单选进行修改")
      }
      const findNoAllow = this.selectedRows.find(item => !(['RELEASED', 'ISSUED', 'DISPATCHED', 'START_WORK'].includes(item.status)))
      if (findNoAllow) {
        return this.$message.warning("只有‘已下达’‘已发放’‘已派工’‘已开工’状态才能修改目的仓")
      }
      const isNotProductJob = this.selectedRows.find(item => item.wipEntityFlag !== 'FINISHED_PRODUCT_JOB')
      if (isNotProductJob) {
       return this.$message.warning("只有成品工单可以修改目的仓")
      }
      this.$refs.DestinationWarehouseModalRef.show(this.selectedRows[0])
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiMesSelectMesWipLogList({ id: row.id }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 工单用料表编辑
    onMaterialEdit(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      this.$refs.UpdateMaterialModalRef.show(this.selectedRows[0], field)
    },
    // 时间编辑
    onEditDate(field) {
      let sign = '' // 特殊标识字段
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      // 计划开始时间、计划完成时间,未下达、已下达、已发放、已派工、已开工的状态都能修改
      if(['scheduledStartDate', 'scheduledCompletionDate'].includes(field)) {
        const findNoAllow = this.selectedRows.find(item => !['UNRELEASED', 'RELEASED', 'ISSUED', 'DISPATCHED', 'START_WORK'].includes(item.status))
        if(findNoAllow) {
          return this.$message.warning("只有‘未下达’‘已下达’‘已发放’‘已派工’‘已开工’状态才能修改")
        }
      }
      // 考核交期判断
      if(field === 'assessmentDeliveryDate') {
        const wipEntityFlag = this.selectedRows[0].wipEntityFlag;
        if(this.selectedRows.find(v => v.wipEntityFlag !== wipEntityFlag)) {
          return this.$message.warning("请单独选择零部件或成品编辑")
        } else {
          sign = wipEntityFlag
        }
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field, sign)
    },
    // 刷新包件版本
    handleRefresh() {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行刷新")
      }
      if (this.selectedRows.length > 1) {
        return this.$message.warning("只能勾选一条数据进行刷新")
      }
      if (this.selectedRows[0].wipEntityFlag !== 'FINISHED_PRODUCT_JOB') {
        return this.$message.warning("只有成品工单可以刷新包装版本")
      }
      // 除了未下达、已下达、已发放、已开工、已派工、已完成，其他状态，不允许变更包件信息
      const refreshStatus = ['UNRELEASED', 'RELEASED', 'ISSUED', 'DISPATCHED', 'START_WORK', 'COMPLETED']
      const findNoAllow = this.selectedRows.find(item => !(refreshStatus.includes(item.status)))
      if (findNoAllow) {
        return this.$message.warning(`${this.selectedRows[0].statusName}状态不允许变更包件信息`)
      }
      this.$refs.RefreshVersionModalRef.show(this.selectedRows[0], 'workOrderDesk')
    },
    handleUpdateTime() {
      // 除了未下达、已下达、已发放、已派工
      const refreshStatus = ['UNRELEASED', 'RELEASED', 'ISSUED', 'DISPATCHED']
      const findNoAllow = this.selectedRows.find(item => !(refreshStatus.includes(item.status)))
      if (findNoAllow) {
        return this.$message.warning(`未下达、已下达、已发放、已派工才能操作`)
      }
      this.btnLoading = true;
      apiWorkOrderDeskLinkageSuperTime(this.selectedRows.map(item => item.id)).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功!')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.btnLoading = false;
      })
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
              this.handleQuery('查询')
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.handleQuery('查询')
    },
    workCodeChange (record) {
      record.lineCode = undefined
    },
    handleScheduledCompletionDateChange (value, mode) {
      this.queryParams.staScheduledCompletionDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endScheduledCompletionDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    handleScheduledStartDateChange (value, mode) {
      this.queryParams.staScheduledStartDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endScheduledStartDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    handleDeliveryDate (value, mode) {
      this.queryParams.staDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 考核交期
    handleAssessmentDeliveryDate (value) {
      this.queryParams.staAssessmentDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endAssessmentDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 未完成数量交期
    handleEstimatedDeliveryDate (value) {
      this.queryParams.staEstimatedDeliveryDate = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams.endEstimatedDeliveryDate = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 公共选择日期
    handleUpdateDate(value, field) {
      this.queryParams[field[0]] = value[0] ? moment(value[0]).format('YYYY-MM-DD 00:00:00') : undefined
      this.queryParams[field[1]] = value[1] ? moment(value[1]).format('YYYY-MM-DD 23:59:59') : undefined
    },
    // 取消
    handleCallOff () {
      this.$refs.cancelModalRef.show(this.selectedRowKeys)
      // this.callOffLoading = true
      // apiMesDiscreteJobsCancellation(this.selectedRowKeys).then(response => {
      //   if (response.code === 200) {
      //     this.$message.success('取消成功!')
      //     this.getList()
      //   } else {
      //     this.$message.error(response.msg)
      //   }
      //   this.callOffLoading = false
      // }).catch(e => {
      //   this.callOffLoading = false
      // })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 下达
    handleXd (ids) {
      // if (ids.length > 1) {
      //   this.$message.warning("请选择一条数据！")
      //   return
      // }
      const self = this
      // this.$confirm({
      //   title: '警告',
      //   content: `真的要下达 编码编号为${ids}的数据项吗?`,
      //   okText: '下达',
      //   okType: 'danger',
      //   cancelText: '取消',
      //   onOk () {
          self.xdLoading = true
          apiMesDiscreteJobsRelease({ ids: ids }).then(response => {
            if (response.code === 200) {
              self.$message.success('下达成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
            self.xdLoading = false
          }).catch(e => {
            self.xdLoading = false
          })
        // }
      // })
    },
    // 工单撤回
    handleGdch (ids) {
      if (ids.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      const self = this
      // this.$confirm({
      //   title: '警告',
      //   content: `真的要工单撤回 编码编号为${ids}的数据项吗?`,
      //   okText: '工单撤回',
      //   okType: 'danger',
      //   cancelText: '取消',
      //   onOk () {
          self.gdchLoading = true
          apiMesDiscreteJobsWithdraw({ ids: ids }).then(response => {
            if (response.code === 200) {
              self.$message.success('工单撤回成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
            self.gdchLoading = false
          }).catch(e => {
            self.gdchLoading = false
          })
      //   }
      // })
    },
    // 异常完工
    handleYcwg (ids) {
      if (ids.length > 1) {
        this.$message.warning("请选择一条数据！")
        return
      }
      if (this.selectedRows[0].status !== "START_WORK") {
        this.$message.warning("只允许已开工的工单进行操作")
        return
      }
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要异常完工 工单号为${this.selectedRows[0].wipEntityName}的数据项吗?`,
        okText: '异常完工',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiMesDiscreteJobsAbnormalCompletion({ ids: ids }).then(response => {
            if (response.code === 200) {
              self.$message.success('异常完工成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    moment,
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
      this.cacheEditObj = deepClone(record)
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.workCode) {
        this.$message.warning('车间不能为空')
        return
      }
      if (!record.lineCode) {
        this.$message.warning('产线不能为空')
        return
      }
      if (!record.mrpFlag) {
        this.$message.warning('MRP净值不能为空')
        return
      }
      if (!record.scheduledStartDate) {
        this.$message.warning('计划开始时间不能为空')
        return
      }
      if (!record.scheduledCompletionDate) {
        this.$message.warning('计划完成时间不能为空')
        return
      }
      const obj = JSON.parse(JSON.stringify(record))
      obj.scheduledStartDate = obj.scheduledStartDate ? this.$moment(obj.scheduledStartDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      obj.scheduledCompletionDate = obj.scheduledCompletionDate ? this.$moment(obj.scheduledCompletionDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      obj.deliveryDate = obj.deliveryDate ? this.$moment(obj.deliveryDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      obj.assessmentDeliveryDate = obj.assessmentDeliveryDate ? this.$moment(obj.assessmentDeliveryDate).format('YYYY-MM-DD HH:mm:ss') : undefined
      apiMesDiscreteJobsUpdate(obj).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false;
          this.getList()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.queryParams.organizationCode = this.organizationCodeOrigin
      this.$nextTick(() => {
        this.$refs.dataTable.searchParams = this.queryParams;
        const self = this;
        const DTDate = this.$refs.dataTable.getData();

        DTDate.then(function (response) {
          // 在这里处理返回的结果
          if (self.currentTab === "工单信息") {
            const arr = []
            const arr2 = []
            response.data.data.records.forEach(element => {
              arr.push(element.id)
              arr2.push(element.orderNo)
            });
            // self.queryParams.wipEntityIds = arr
            self.orderNos = Array.from(new Set(arr2))

            self.typeList = response.rows
            self.total = response.total
            self.tableLoading = false
          }
        })
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 关闭工单
    handleClose(ids) {
      this.closeLoading = true
      apiMesDiscreateBatchClose(ids).then(response => {
        if (response.code === 200) {
          this.$message.success('关闭工单成功!')
          this.getList()
        } else {
          this.$message.error(response.msg)
        }
        this.closeLoading = false
      }).catch(() => {
        this.closeLoading = false
      })
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      this.uploadLoading = true;
      if (status !== 'uploading') {
        this.uploadLoading = false;
      }
      if (info.file.response.code === 500) {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
        return
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.uploadLoading = false;
      this.excelVisible = true
    },
    // 页签-切换
    tabOnchange (val) {
      this.currentTab = val
      if (val === "工单信息") {
        const obj = {
          title: '操作',
          width: 130,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
        const obj2 = JSON.parse(JSON.stringify(this.columns1))
        obj2.push(obj)
        this.columns = obj2
        this.scrollWidth = 4200
        this.exportUrl = apiMesDiscreteJobsExport
      }
      if (val === "工单用料表") {
        this.columns = JSON.parse(JSON.stringify(this.columns2))
        this.scrollWidth = 2500
        this.exportUrl = apiMesRequirementOperationsExport
      }
      if (val === "工单工序") {
        this.columns = JSON.parse(JSON.stringify(this.columns3))
        this.scrollWidth = 2200
        this.exportUrl = apiMesOperationsExport
      }
      if (val === "关联工单") {
        this.columns = JSON.parse(JSON.stringify(this.columns1))
        this.scrollWidth = 4100
        this.exportUrl = apiAssociatedWorkOrderExport
      }
      this.handleQuery()
    },
    // 关闭工单导入
    handleImport(value) {
      const { file } = value
      // 校验文件类型
      const verifyFileName = file.name.substring(file.name.lastIndexOf("."))
      const acceptList = this.uploadConfig.accept.split(',')
      if(acceptList.indexOf(verifyFileName.toLowerCase()) === -1) {
        this.$message.warning('上传格式不正确，仅支持：' + this.uploadConfig.accept)
        return false;
      }
      const formData = new FormData()
      formData.append("file", file)
      this.closeUploading = true;
      apiBatchCloseImport(formData).then(res => {
        parseResFileOrJson(res, () => {
          this.onSearch(); // 重新查询
        }, '关闭工单导入异常.xlsx');
      }).finally(() => {
        this.closeUploading = false;
      })
    },
    // 修改考核交期
    handleUpdateAssessmentDelivery() {
      if(this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      const ids = this.selectedRows.map(item => item.id)
      this.deliveryLoading = true
      apiCheckAssessmentDeliveryDateCanSubmit(ids).then(res => {
        if(res?.code === 200 && res?.data === true) {
          this.$refs.updateAssessmentDeliveryDateRef.show(this.selectedRows, 'workOrderDesk')
        } else {
          this.$message.error('超出考核交期，无法发起修改考核交期')
        }
      }).finally(() => {
        this.deliveryLoading = false
      })
    },
    // 工单批量关闭导入模板下载
    handleDownloadTemplate() {
      this.$message.loading({ content: '下载中...' })
      this.downloadByJson('mes/mesDiscreteJobs/batchCloseTemplate', {}, `关闭工单导入模板下载_${moment().format('YYYY-MM-DD')}.xlsx`)
    },
    /** 下载模板操作 */
    importTemplate () {
      apiMesDiscreteJobsTemplate(this.queryParams).then(res => {
        window.location.href = res.data
      })
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.$nextTick(() => {
        const params = { ...this.queryParams }
        this.$refs.download.openModal(params)
      })
    },
    /** 查询快码类型列表 */
    getList () {
      this.currentTab === "工单信息" && this.gdxx()
      this.currentTab === "工单用料表" && this.gdylb()
      this.currentTab === "工单工序" && this.gdgx()
      this.currentTab === "关联工单" && this.glgd()
    },
    // 工单信息
    gdxx () {
      this.tableProps.requestApi = generateLsTableResData(apiMesDiscreteJobsList, true)
      this.queryParams.wipEntityIds = []
      this.onSearch()
    },
    // 工单用料表
    gdylb () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesRequirementOperationsList, true));
      this.onSearch()
    },
    // 工单工序
    gdgx () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesOperationsList, true));
      this.onSearch()
    },
    // 关联工单
    glgd () {
      this.$set(this.tableProps, 'requestApi', generateLsTableResData(apiMesDiscreteJobsAssociatedWorkOrderList, true));
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery (val) {
      // if (val === "查询" && this.currentTab !== "工单信息") {
      //   return
      // }
      this.onChangeCopyFormExcel('wipEntityNameVal', 'wipEntityNameList')
      this.onChangeCopyFormExcel('orderNoVal', 'orderNoList')
      this.queryParams.pageNum = 1
      this.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        organizationCode: undefined,
        wipEntityNameVal: undefined,
        wipEntityNameList: undefined,
        statusList: undefined,
        assemblyItemIdList: undefined,
        lineIdList: undefined,
        desOrganizationCodeList: undefined,
        classCodeList: undefined,
        orderNoVal: undefined,
        orderNoList: undefined,
        createBy: undefined,
        scheduledCompletionDate: undefined,
        scheduledStartDate: undefined,
        staEstimatedDeliveryDate: undefined,
        endEstimatedDeliveryDate: undefined,
        approvalStatusList: undefined,
        workshopCodes: undefined,
        wipEntityFlag: undefined,
        staDispatchingDate: undefined,
        endDispatchingDate: undefined,
        staStartDate: undefined,
        endStartDate: undefined,
        staCompletionDate: undefined,
        endCompletionDate: undefined,
        staFirstReportingTime: undefined,
        endFirstReportingTime: undefined,
        vendorCode: undefined,
        orderTypeList: undefined,
        itemIdList: undefined,
        staCreateTime: undefined,
        endCreateTime: undefined
      }
      this.scheduledCompletionDate = undefined; // 计划完成时间
      this.scheduledStartDate = undefined; // 计划开始时间
      this.deliveryDate = undefined; // 一次达交考核时间
      this.assessmentDeliveryDate = undefined; // 考核交期
      this.estimatedDeliveryDate = undefined; // 未完成数量交期
      this.dispatchingDate = undefined; // 派工时间
      this.startDate = undefined; // 开工时间
      this.completionDate = undefined; // 完工时间
      this.firstReportingTime = undefined; // 第一次报工时间
      this.createTime = undefined; // 创建时间
      this.workshopCodeList = []; // 车间清空
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 车间
    getWorkCodeBox () {
      apiMesDiscreteJobsWorkCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.workCodeList = res.data;
        }
      })
    },
    // 产线
    getLineCodeBox () {
      apiMesDiscreteJobsLineCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.lineCodeList = res.data;
        }
      })
    },
    // 工单分类
    getClassCodeBox () {
      apiMesDiscreteJobsClassCodeBox().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.classCodeList = res.data;
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.itemcode{
  /deep/.ant-form-item-children{
    display: flex;
    align-items: center;
  }
}
.page-header-content{
  /deep/.ant-select{
    width: 140px !important;
  }
  /deep/.ant-calendar-picker{
    // min-width: 160px !important;
  }
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
.line-height37 {
  line-height: 37px;
}
</style>
